import Rails from 'rails-ujs';
import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = [ 'checkBox' ]

  onCheck() {
    if (this.checkBoxTarget.checked){
      if (confirm('[Smaview] 登録してよろしいですか？')){
        this.setSmaviewAvailable()
      } else {
        this.checkBoxTarget.checked = false
      }
    } else {
      if (confirm('[Smaview] 解除してよろしいですか？')){
        this.setSmaviewAvailable()
      } else {
        this.checkBoxTarget.checked = true
      }
    }
  }

  setSmaviewAvailable(){
    Rails.ajax({
      type: 'PATCH',
      dataType: 'json',
      url: `/api/estates/${ this.checkBoxTarget.defaultValue }/update_smaview_available?smaview_available=${ this.checkBoxTarget.checked }`,
      success: (json) => {
        if (json.smaview_available) {
          alert('[Smaview] 登録しました')
        } else {
          alert('[Smaview] 解除しました')
        }
      },
      error: (json) => {
        alert('エラーが発生しました。ブラウザをリロードして、再度お試しください。')
      }
    })
  }
}
